var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCssIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 75,
    viewBox: "0 0 66 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_871_343)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.7255 0L59.7491 67.0536L32.8325 74.5015L6.00657 67.0536L0.0301514 0H65.7255Z",
    fill: "#264DE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6329 62.775L59.7264 5.47839H32.8778V68.7967L54.6329 62.775Z",
    fill: "#2965F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7487 30.3574L14.4732 38.575H32.8778V30.3574H13.7487Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8778 13.6959H32.8552H12.2546L13.0017 21.9361H32.8778V13.6959Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8778 60.2622V51.7051L32.8552 51.7277L23.6868 49.2376L23.0982 42.6952H18.6612H14.858L15.9899 55.5988L32.8552 60.2849L32.8778 60.2622Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9743 38.575L42.0235 49.2375L32.8552 51.7277V60.2848L49.7204 55.5988L49.8336 54.2178L51.7805 32.5533L51.9616 30.3575L53.4557 13.6959H32.8552V21.9361H44.4458L43.6987 30.3575H32.8552V38.575H42.9743Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.0376282,
    width: 65.6953,
    height: 74.5015,
    style: {
      mixBlendMode: "saturation"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_871_343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.6953,
    height: 74.5015,
    fill: "white",
    transform: "translate(0.0376282)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssIcon);
export default __webpack_public_path__ + "static/media/css-icon.7026cc422deba8c53455112da8e0174d.svg";
export { ForwardRef as ReactComponent };